import { createContext, useContext } from 'react';

import type { IUsePanelHistory } from '../hooks/panel-history';

export const PanelHistoryContext = createContext<IUsePanelHistory | null>(null);

export const usePanelHistoryContext = (): IUsePanelHistory => {
	const panelHistoryContext = useContext(PanelHistoryContext);

	if (!panelHistoryContext) {
		throw new Error('useGlobalContext must be used within a GlobalProvider');
		// } catch (error) {}
	}

	return {
		...panelHistoryContext,
	};
};
